<template>
  <BaseLoader v-if="!$store.getters.isLoaded(['orders', 'shelves'])" />
  <div v-else-if="order && !order.orderJobId">
    <div
      class="mt-2 mb-3 d-flex flex-column flex-sm-row justify-content-between align-items-sm-end"
      style="border-bottom: 1px #ccc solid;"
    >
      <div class="mb-2 mb-sm-1 ml-2 ml-sm-0 text-truncate">
        <h1 class="h4 mb-0 text-truncate">{{ order.organizationName }}</h1>
        <small class="d-block">{{ order.createdAt.toDate() | date }}</small>
      </div>
      <ul class="nav nav-tabs flex-shrink-0" style="margin-bottom: -1px;">
        <li class="nav-item">
          <button
            class="nav-link order__nav-link"
            :class="{ active: activeTab === 'overview' }"
            @click="activeTab = 'overview'"
          >
            Overview
          </button>
        </li>
        <li class="nav-item">
          <button
            class="nav-link order__nav-link"
            :class="{ active: activeTab === 'missing' }"
            @click="activeTab = 'missing'"
          >
            Missing
            <span class="badge ml-1" :class="missingItemCounts.products > 0 ? 'badge-warning' : 'badge-success'">{{
              missingItemCounts.products
            }}</span>
          </button>
        </li>
        <li class="nav-item">
          <button
            class="nav-link order__nav-link"
            :class="{ active: activeTab === 'pick' }"
            @click="activeTab = 'pick'"
          >
            Pick
            <span class="badge ml-1" :class="pickableItems.open.length > 0 ? 'badge-warning' : 'badge-success'">{{
              pickableItems.open.length
            }}</span>
          </button>
        </li>
        <li class="nav-item">
          <button
            class="nav-link order__nav-link"
            :class="{ active: activeTab === 'ship' }"
            @click="activeTab = 'ship'"
          >
            Ship
          </button>
        </li>
      </ul>
    </div>
    <div
      class="alert alert-warning mt-4 mb-5"
      v-if="missingItemCounts.products !== 0 && ['overview', 'pick'].includes(activeTab)"
      @click="activeTab = 'missing'"
    >
      <h2 class="h5 mb-1">
        {{ missingItemCounts.products === 1 ? 'One Product is' : `${missingItemCounts.products} Products are` }} Missing
        ⚠️
      </h2>
      <small class="m-0">Please don't fulfill this order before all products are available.</small>
    </div>
    <Overview v-if="activeTab === 'overview'" />
    <MissingItemsList
      v-if="activeTab === 'missing'"
      :missingItems="missingItems"
      :missingItemCounts="missingItemCounts"
    />
    <Pick v-if="activeTab === 'pick'" :order="this.order" />
    <Ship v-if="activeTab === 'ship'" />
  </div>
  <p class="alert alert-warning mt-3" v-else-if="order.orderJobId">
    Die Order wird mit Warehouse Next gepackt
  </p>
  <p class="alert alert-warning mt-3" v-else>
    Order not found
  </p>
</template>

<script>
import Overview from '@/components/Order/Overview'
import Pick from '@/components/Order/Pick'
import MissingItemsList from '@/components/Order/MissingItemsList'
import Ship from '@/components/Order/Ship'
import PickPlan from '@/helpers/PickPlan'

import { MissingItems, MissingItemCounts } from '@/helpers/Calculator'
export default {
  components: { Overview, Pick, MissingItemsList, Ship },
  data() {
    return {
      activeTab: 'overview'
    }
  },
  created() {
    this.$route.meta.backLink = `/orders/`
  },
  computed: {
    order() {
      return this.$store.state.orders.find(o => o.id === this.$route.params.orderId)
    },
    missingItems() {
      return MissingItems([this.order], this.$store.state.shelves)
    },
    missingItemCounts() {
      return MissingItemCounts(this.missingItems)
    },
    pickableItems() {
      return PickPlan.calculate(this.order)
    }
  },
  filters: {
    date(date) {
      const dateString = date.toLocaleDateString('de-DE', {
        day: '2-digit',
        month: '2-digit'
      })
      const timeString = date.toLocaleTimeString('de-DE', {
        hour: '2-digit',
        minute: '2-digit'
      })
      return `${dateString} - ${timeString}`
    }
  }
}
</script>

<style lang="scss" scoped>
.order {
  &__nav-link {
    outline: none;
  }
}
</style>
